// ─── Styles ───────────────────────────────────────────────────────────────────
import '../scss/style.scss';

// ─── Alpine.js ────────────────────────────────────────────────────────────────
import Alpine from 'alpinejs';

// ─── Swiper (import only what is needed to keep bundle lean) ──────────────────
import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';
import 'swiper/css';

// ─── Local modules ────────────────────────────────────────────────────────────
import { initNavigation, initMobileSubmenu, initStickyHeader } from './modules/navigation.js';
import {initShowsSwiper, initSponsorsSwiper} from './modules/shows-swiper.js';
import { initGalleryCard } from './modules/gallery-card.js';
import {initLoadMore} from "./modules/loadMore.js";

// ─── Boot ─────────────────────────────────────────────────────────────────────
document.addEventListener( 'DOMContentLoaded', () => {
	initNavigation();
	initMobileSubmenu();
	initStickyHeader();
	initLoadMore();
	initShowsSwiper( Swiper, { Navigation, Pagination, A11y } );
	initSponsorsSwiper( Swiper, { Navigation, Pagination, A11y } );
	initGalleryCard( Swiper, { Navigation, Pagination, A11y, Keyboard } );
} );

Alpine.start();
